import React from "react";
import "../../../incidents/cases/addCaseList.scss";
import Buttons from "../../../../library/custom/button/Button";
import ContractorTable from "./contractorTable";
import { InactiveClient } from "../../../../utils/helper";

export default function ContractorList({
  NavigateSingleUser,
  contractorListData,
  getContractorListData,
  loading,
  deleteList,
  contractorGrades,
  contractorTypes,
  isShowDowdownloadButton,
  sendBulkEmailVarifation,
  setClickVerifyBtn,
  setAccessUserId,
  accessUserId,
  ContractorListDatas,
  shouldRestoreState,
  division,
}) {
  const handleClickAdd = (event) => {
    if (InactiveClient()) return;
    NavigateSingleUser();
  };
  return (
    <>
      <section className="grid_main_sec">
        <div className="grid_main_header two_grid">
          <div className="grid_heading_style">Subcontractor List</div>

          <div>
            <Buttons
              id="btnAddContractor"
              varientAddIconBlue={true}
              label={"Add Subcontractor"}
              onClick={(e) => handleClickAdd(e)}
            />
          </div>
        </div>
        <ContractorTable
          contractorListData={contractorListData}
          getContractorListData={getContractorListData}
          loading={loading}
          deleteList={deleteList}
          contractorGrades={contractorGrades}
          filterShow={true}
          contractorTypes={contractorTypes}
          isShowDowdownloadButton={isShowDowdownloadButton}
          sendBulkEmailVarifation={sendBulkEmailVarifation}
          setClickVerifyBtn={setClickVerifyBtn}
          setAccessUserId={setAccessUserId}
          accessUserId={accessUserId}
          ContractorListDatas={ContractorListDatas}
          shouldRestoreState={shouldRestoreState}
          division={division}
        />
      </section>
    </>
  );
}
